import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import 'virtual:uno.css';
import { initConfig } from '@borealis/huck/client';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { dynamicActivate } from '../activate-client-locale.js';
import { App } from './App.js';
import '@warp-ds/elements/components/toast';
import './styles.css';
import { getHuckConfig } from './utils/getHuckConfig.js';

const root = document.querySelector('#mobility-item-insertion-form-root');

if (root) {
  initConfig(root);
}

async function hydrate() {
  const config = getHuckConfig();

  if (!config.locale) {
    console.error("No locale in config - falling back to 'en'", config);
  }

  await dynamicActivate(config.locale ?? 'en');

  if (!root) {
    console.error('Root element not found');
    return;
  }

  ReactDOM.hydrateRoot(
    root,
    <I18nProvider i18n={i18n}>
      <BrowserRouter basename={config.root}>
        <App />
      </BrowserRouter>
    </I18nProvider>,
  );
}

hydrate();
